import UserResaults from '../components/users/UserResaults'
import UserSearch from '../components/users/UserSearch'

function Home () {
  return (
    <>
      <UserSearch />
      <UserResaults />
    </>
  )
}

export default Home